"use client";
import ProductVariantAttributeValuesSwiper from "./productVariantAttributeValuesSwiper";

import configureProductVariant from "@/app/ec/product/[basePath]/product-variants/configureProductVariant";

import style from "./productVariantPicker.module.scss";

function ProductVariantPicker({
  variantGroupDetails,
  onVariantNavigationStart,
  variantNavigationLocked = false,
}: ProductVariantPickerProps) {
  const productAttributeStates = configureProductVariant(variantGroupDetails);

  return (
    <div className={style.ProductVariantPicker}>
      {productAttributeStates?.map((productAttributeState, index) => {
        return (
          <ProductVariantAttributeValuesSwiper
            key={index}
            atributeName={productAttributeState.selectedAttributeName}
            atributeValue={productAttributeState.selectedAttributeValue}
            productAttributeState={productAttributeState}
            onVariantNavigationStart={onVariantNavigationStart}
            variantNavigationLocked={variantNavigationLocked}
          />
        );
      })}
    </div>
  );
}

type ProductVariantPickerProps = {
  variantGroupDetails: ProductVariantResponse;
  onVariantNavigationStart: () => void;
  variantNavigationLocked?: boolean;
};

export default ProductVariantPicker;
